import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/application/Auth/_redux/authRedux";
import {adminsSlice} from "../app/application/Admin/_redux/admins/adminsSlice";
import {categoriesSlice} from "../app/application/Admin/_redux/categories/categoriesSlice";
import {subcategoriesSlice} from "../app/application/Admin/_redux/subcategories/subcategoriesSlice";
import {subscriptionsSlice} from "../app/application/Admin/_redux/subscriptions/subscriptionsSlice";
import {usersSlice} from "../app/application/Admin/_redux/users/usersSlice";
import {businessesSlice} from "../app/application/Admin/_redux/businesses/businessesSlice";
import {countriesSlice} from "../app/application/Admin/_redux/countries/countriesSlice";
import {statesSlice} from "../app/application/Admin/_redux/states/statesSlice";
import {citiesSlice} from "../app/application/Admin/_redux/cities/citiesSlice";
export const rootReducer = combineReducers({
  auth: auth.reducer,
  admins: adminsSlice.reducer,
  categories: categoriesSlice.reducer,
  subcategories: subcategoriesSlice.reducer,
  subscriptions: subscriptionsSlice.reducer,
  users: usersSlice.reducer,
  businesses: businessesSlice.reducer,
  countries: countriesSlice.reducer,
  states: statesSlice.reducer,
  cities: citiesSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
